import { createRouter, createWebHistory } from 'vue-router';
import { logout, getUser } from "@/services/authService"; 
import { usePermissionStore } from '@/stores/permissionStore'
// Auth
import LoginScreen from '../views/login/LoginScreen.vue';
import RegisterScreen from '../views/login/RegisterScreen.vue';
import ResetPassword from '../views/login/ResetPassword.vue';

import SchedulePage from '@/views/schedule/SchedulePage.vue';

// Visões gerais
import NotFound from '../views/templates/NotFound.vue';
import Offline from '../views/templates/OfflineScreen.vue';


// Configurações
import ConfigScreen from '../views/settings/ConfigScreen.vue';
import GestaoAgendas from '../views/settings/ScheduleManagement.vue';
import GestaoMaskLaudos from '../views/settings/GestaoMaskLaudos.vue';
import MeuPerfil from '../views/settings/MeuPerfil.vue';
import ServicesManagement from '@/views/settings/ServicesManagement.vue';
import InsuranceManagement from '@/views/settings/InsuranceManagement.vue';
import RoomManagement from '@/views/settings/RoomManagement.vue';
import MonitoramentoPage from '@/views/settings/MonitorManagement.vue';
import GestaoUsuarios from '@/views/settings/GestaoUsuarios.vue';
import GestaoGrupos from '@/views/settings/GestaoAcessos.vue';
import GestaoPermissoesGrupo from '@/views/settings/GestaoPermissoesGrupo.vue'

// Outros

import HomePage from '../views/home/HomePage.vue';
import VersionPage from '../views/templates/VersionPage.vue';
import NotificationPage from '../views/notifications/NotificationPage.vue';
import LaudoPage from '../views/medicalreports/LaudoPage.vue';
import PatientsPage from '@/views/patients/PatientsPage.vue';
import WebhookManagement from '@/views/settings/WebhookManagement.vue';
import NotificationManagement from '@/views/settings/NotificationManagement.vue';
import AuditView from '@/views/settings/AuditView.vue';
import DoctorManagement from '@/views/settings/DoctorManagement.vue';
import AnamnesisManagement from '@/views/settings/AnamnesisManagement.vue';
import ComponentViewer from '@/views/viewer/ComponentViewer.vue';
import ShareViewer from '@/views/viewer/ShareViewer.vue';
import AtendimentoPage from '@/views/Atendimento/AtendimentoPage.vue';
import MonitorPage from '@/views/Monitor/MonitorPage.vue';
import ClinicSettings from '@/views/settings/ClinicSettings.vue';
import ReportsPage from '@/views/Reports/ReportsPage.vue';
import ExamDelivery from '@/views/ExamDelivery/ExamDelivery.vue';
import LaudoPopup from '@/views/medicalreports/LaudoPopup.vue';
import EditExam from '@/views/EditExam/EditExam.vue';
import ExamRelease from '@/views/ExamRelease/ExamRelease.vue';
import FaturamentoPage from '@/views/Faturamento/FaturamentoPage.vue';
import RecallQueuePage from '@/views/RecallQueue/RecallQueuePage.vue';


const routes = [
  {
    path: "/",
    name: "Login",
    component: LoginScreen,
    meta: { title: "Login - InovaMed" },
  },
  {
    path: "/home",
    name: "HomePage",
    component: HomePage,
    meta: { requiresAuth: true, title: "Tela de Início" },
    props: true,
  },
  {
    path: "/schedule",
    name: "SchedulePage",
    component: SchedulePage,
    meta: { requiresAuth: true, title: "Tela de Agendamento", requiredPermission: "can_access_schedule" },
    props: true,
  },
  {
    path: "/config/users",
    name: "GestaoUsuarios",
    component: GestaoUsuarios,
    meta: { requiresAuth: true, title: "Gestão de Usuários", requiredPermission: "can_manage_users" },
    props: true,
  },
  {
    path: "/config/groups",
    name: "GestaoGrupos",
    component: GestaoGrupos,
    meta: { requiresAuth: true, title: "Gestão de Grupos", requiredPermission: "can_manage_groups" },
    props: true,
  },
  {
    path: "/reports",
    name: "ReportsPage",
    component: ReportsPage,
    meta: { requiresAuth: true, title: "Relatórios", requiredPermission: "can_access_reports" },
    props: true,
  },
   {
    path: "/settings/schedule",
    name: "SettingsSchedulePage",
    component: GestaoAgendas,
    meta: { requiresAuth: true, title: "Tela de Agendamento" },
    props: true,
  },
    {
    path: "/patients",
    name: "PatientsPage",
    component: PatientsPage,
    meta: { requiresAuth: true, title: "Gestão de Pacientes", requiredPermission: "can_access_patients" },
    props: true,
  },
      {
    path: "/settings/clinic",
    name: "ClinicSettings",
    component: ClinicSettings,
    meta: { requiresAuth: true, title: "Configurações da Clínica", requiredPermission: "can_manage_clinic_settings" },
    props: true,
  },
    {
    path: "/medicalreports",
    name: "LaudoPage",
    component: LaudoPage,
    meta: { requiresAuth: true, title: "Tela de Laudos", requiredPermission: "can_access_medicalreports" },
    props: true,
  },
    {
    path: "/settings/mask",
    name: "MaskPage",
    component: GestaoMaskLaudos,
    meta: { requiresAuth: true, title: "Gestão de Máscaras de Laudo", requiredPermission: "MaskLaudos.list_mascaras_laudo" },
    props: true,
  },
  {
    path: "/notifications",
    name: "Notificações",
    component: NotificationPage,
    meta: { title: "Notificação - InovaMed" },
  },
  {
    path: "/register",
    name: "Register",
    component: RegisterScreen,
    meta: { title: "Cadastro - InovaMed" },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: { title: "Recuperar Senha - InovaMed" },
  },
  {
    path: "/version",
    name: "VersionPage",
    component: VersionPage,
    meta: { title: "Versão do Software" },
  },
  {
    path: "/meuperfil",
    name: "MeuPerfil",
    component: MeuPerfil,
    meta: { title: "Meu Perfil",
      requiresAuth: true,
     },
  },


  {
    path: "/offline",
    name: "Offline",
    component: Offline,
    meta: { title: "Offline - InovaMed" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: { title: "Página Não Encontrada - InovaMed" },
  },
  {
    path: "/atendimento",
    name: "AtendimentoPage",
    component: AtendimentoPage,
    meta: { title: "Atendimento - InovaMed", requiresAuth: true, requiredPermission: "can_access_atendimento" },
  },
  {
    path: "/settings/monitor",
    name: "MonitoramentoPage",
    component: MonitoramentoPage,
    meta: { title: "Monitoramento - InovaMed", requiresAuth: true, requiredPermission: "can_manage_monitor_settings" },
  },
  {
    path: "/settings/rooms",
    name: "RoomManagement",
    component: RoomManagement,
    meta: { title: "Configurações - Salas", requiresAuth: true, requiredPermission: "can_manage_room_settings" },
  },

  
  {
    path: "/config",
    name: "ConfigScreen",
    component: ConfigScreen,
    meta: {
      requiresAuth: true,
      requiredPermission: "can_access_config",
      title: "Configurações - InovaMed",
    },
  },
    {
    path: "/settings/doctors",
    name: "DoctosrsManagement",
    component: DoctorManagement,
    meta: {
      requiresAuth: true,
      requiredPermission: "can_manage_doctor_settings",
      title: "Configurações - Médicos",
    },
  },
  {
    path: "/settings/services",
    name: "Services",
    component: ServicesManagement,
    meta: {
      requiresAuth: true,
      requiredPermission: "can_manage_service_settings",
      title: "Configurações - Serviços",
    },
  },
    {
    path: "/settings/anamnesis",
    name: "anamnesis",
    component: AnamnesisManagement,
    meta: {
      requiresAuth: true,
      requiredPermission: "can_manage_anamnesis_settings",
      title: "Configurações - Anamneses",
    },
  },
    {
    path: "/settings/insurances",
    name: "InsuranceManagement",
    component: InsuranceManagement,
    meta: {
      requiresAuth: true,
      requiredPermission: "can_manage_insurance_settings",
      title: "Configurações - Convênios",
    },
  },

      {
    path: "/settings/webhook",
    name: "Webhook",
    component: WebhookManagement,
    meta: {
      requiresAuth: true,
      requiredPermission: "can_manage_webhook_settings",
      title: "Configurações - Webhook",
    },
  },
   {
    path: "/settings/notifications",
    name: "Notifications",
    component: NotificationManagement,
    meta: {
      requiresAuth: true,
      requiredPermission: "can_manage_notification_settings",
      title: "Configurações - Notificações",
    },
  },
    {
    path: "/settings/audit",
    name: "AuditView",
    component: AuditView,
    meta: { title: "Auditoria", requiresAuth: true, requiredPermission: "can_view_audit" },
  },
  {
    path: "/viewer",
    name: "Viewer",
    component: ComponentViewer,
    meta: { title: "Viewer", requiresAuth: true, requiredPermission: "can_access_viewer" },
  },
  {
    path: "/pacs/viewer/",
    name: "PacsViewer",
    // Carregamento dinâmico para não pesar o bundle principal
    component: () => import('@/views/medicalreports/PacsViewerPlaceholder.vue'),
    meta: { requiresAuth: true, title: "Visualizador PACS" },
    props: true,
  },
  {
    path: "/monitor",
    name: "MonitorPage",
    component: MonitorPage,
    meta: { title: "Monitor de Chamadas" },
  },
  {
    path: "/entrega-exames",
    name: "ExamDelivery",
    component: ExamDelivery,
    meta: { 
      requiresAuth: true, 
      title: "Entrega de Exames",
      requiredPermission: "can_access_exam_delivery"
    },
  },
  {
    path: '/settings/permissoesgrupo',
    name: 'GestaoPermissoesGrupo',
    component: GestaoPermissoesGrupo,
    meta: { title: "Permissões de Grupo", requiresAuth: true, requiredPermission: "can_manage_permissions" },
  },
  {
    path: '/laudo-popup',
    name: 'LaudoPopup',
    component: LaudoPopup,
    meta: { 
      title: "Laudo Médico", 
      requiresAuth: true,
      requiredPermission: "can_access_medicalreports"
    },
  },
  {
    path: '/shared-viewer',
    name: 'ShareViewer',
    component: ShareViewer,
    meta: { 
      title: "Visualizador Compartilhado",
      requiresAuth: false // Não requer autenticação pois é acesso via link
    },
  },
  {
    path: '/editexam',
    name: 'EditExam',
    component: EditExam,
    meta: { title: "Editar Exame", requiresAuth: true, requiredPermission: "can_access_edit_exam" },
  },
  {
    path: '/recall-queue',
    name: 'RecallQueue',
    component: RecallQueuePage,
    meta: { 
      title: "Fila de Reconvocação", 
      requiresAuth: true,
      requiredPermission: "can_access_recall_queue"
    },
  },
  {
    path: '/exam-release',
    name: 'ExamRelease',
    component: ExamRelease,
    meta: { title: "Liberar Exames", requiresAuth: true, requiredPermission: "can_access_exam_release" },
  },
  {
    path: '/faturamento',
    name: 'FaturamentoPage',
    component: FaturamentoPage,
    meta: { title: "Faturamento", requiresAuth: true},
    children: [
      {
        path: '',
        redirect: '/faturamento/tabelas'
      },
      {
        path: 'tabelas',
        name: 'FaturamentoTabelas',
        component: () => import('@/views/Faturamento/components/TabelasView.vue'),
        meta: { title: "Tabelas - Faturamento", requiresAuth: true }
      },
      {
        path: 'gerar-faturas',
        name: 'FaturamentoGerarFaturas',
        component: () => import('@/views/Faturamento/components/GerarFaturasView.vue'),
        meta: { title: "Gerar Faturas - Faturamento", requiresAuth: true }
      },
      {
        path: 'faturas-geradas',
        name: 'FaturamentoFaturasGeradas',
        component: () => import('@/views/Faturamento/components/FaturasGeradasView.vue'),
        meta: { title: "Faturas Geradas - Faturamento", requiresAuth: true }
      },
      {
        path: 'procurar-conta',
        name: 'FaturamentoProcurarConta',
        component: () => import('@/views/Faturamento/components/ProcurarContaView.vue'),
        meta: { title: "Procurar Conta - Faturamento", requiresAuth: true }
      },
      {
        path: 'recalcular-periodo',
        name: 'FaturamentoRecalcularPeriodo',
        component: () => import('@/views/Faturamento/components/RecalcularPeriodoView.vue'),
        meta: { title: "Recalcular Período - Faturamento", requiresAuth: true }
      },
      {
        path: 'recurso-glosa',
        name: 'FaturamentoRecursoGlosa',
        component: () => import('@/views/Faturamento/components/RecursoGlosaView.vue'),
        meta: { title: "Recurso Glosa - Faturamento", requiresAuth: true }
      },
      {
        path: 'auditoria-calculo-conta',
        name: 'FaturamentoAuditoriaCalculoConta',
        component: () => import('@/views/Faturamento/components/AuditoriaCalculoContaView.vue'),
        meta: { title: "Auditoria de Cálculo de Conta - Faturamento", requiresAuth: true }
      },
      {
        path: 'bpa',
        name: 'FaturamentoBPA',
        component: () => import('@/views/Faturamento/components/BPAView.vue'),
        meta: { title: "BPA - Faturamento", requiresAuth: true }
      }
    ]
  },
  {
    path: '/estoque',
    name: 'EstoquePage',
    component: () => import('@/views/Estoque/EstoqueView.vue'),
    meta: { title: "Estoque", requiresAuth: true, requiredPermission: "Estoque.can_access_estoque" },
  },
];

// Criação do roteador
const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  try {
    // Atualiza o título da página dinamicamente
    document.title = to.meta.title || "InovaMed | Revolucionando a Gestão Médica";

    // Verifica conexão offline
    if (!navigator.onLine) {
      if (to.name !== "Offline") {
        return next({
          name: "Offline",
          query: { redirect: to.fullPath },
        });
      }
    } else if (to.name === "Offline") {
      const redirect = to.query.redirect || "/";
      return next(redirect);
    }

    // Verifica se a rota exige autenticação
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    if (!requiresAuth) return next();

    // Verifica se o usuário está autenticado
    const user = await getUser(); // Pode ser `isAuthenticated()` ou `getUser()`
    if (!user) {
      await logout(); // Limpa sessão, tokens, etc.
      return next({ name: "Login", query: { accessDenied: true } });
    }

    // Verifica permissões específicas
    const requiredPermission = to.meta.requiredPermission;
    if (requiredPermission) {
      const permissionStore = usePermissionStore();
      console.log(`Verificando permissão para rota ${to.name}: ${requiredPermission}`);
      console.log('Permissões do usuário:', permissionStore.userPermissions);
      const hasPermission = permissionStore.hasPermission(requiredPermission);
      console.log(`Usuário tem permissão ${requiredPermission}: ${hasPermission}`);
      
      if (!hasPermission) {
        console.log(`Acesso negado para rota ${to.name} - permissão ${requiredPermission} não encontrada`);
        return next({
          name: "HomePage", // Redireciona para home se não tiver permissão
          query: { unauthorized: true },
        });
      }
    }

    next(); // Tudo certo, permite navegação

  } catch (error) {
    console.error("Erro no middleware de rota:", error);
    await logout(); // Por segurança
    return next({ name: "Login", query: { error: true } });
  }
});






export default router;
